<template>
  <div class="header-box">
    <div style="width: 100%;" v-if="scrollTop > 0"></div>
    <div :class="['header', scrollTop > 0 ? 'scrollTopFixed' : '']">
      <div class="header-left">
        <div class="logoBox">
          <!--          <img class="logo-img" :src="require('@/assets/home/logo.png')" alt="">-->
          <div class="logo-name">{{ $t('header.title') }}</div>
        </div>
        <div class="menu-style">
          <a-menu v-model="currents" mode="horizontal">
            <template v-for="(item,index) in menuList">
              <template v-if="!item.children?.length">
                <a-menu-item :key="item.key" @click="seleMenu(item.key)">{{ $t(`header.menus.${index}.name`) }}</a-menu-item>
              </template>
              <template v-else>
                <a-sub-menu :key="item.key">
                  <span slot="title" class="submenu-title-wrapper" @click="seleMenu(item.key)">{{ $t(`header.menus.${index}.name`) }}</span>
                  <a-menu-item v-for="(subItem,itemIndex) in item.children" :key="subItem.key" @click="selectChildren(subItem)">
                   {{ $t(`header.menus.${index}.children.${itemIndex}`) }}
                  </a-menu-item>
                </a-sub-menu>
              </template>
            </template>
          </a-menu>
        </div>
      </div>
      <!-- 搜索 -->
      <!-- <div class="input-style">
        <a-input-search placeholder="请输入关键词" style="width: 200px" @search="onSearch" />
      </div> -->

      <!-- 电话 -->
      <div class="generaPhone-box">
        <img class="generaPhoneImg"
          :src="scrollTop > 0 ? require('@/assets/home/phone.png') : require('@/assets/home/generaPhone.png')" alt="">
        <div class="generaPhone">19106337398</div>
      </div>

      <div class="langBtn" @click="changeLang">{{ otherLang }}</div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
export default {
  props: {
    scrollTop: {
      type: Number,
      default: 0,
    },
    current: {
      type: Array,
      default: () => ["home"],
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
      currents: [],
      otherLang: 'Switch To English',
      currnLang: 'zh-cn',
    }
  },
  watch: {
    current: {
      immediate: true,
      deep: true,
      handler(val, oldName) {
        this.currents = val
        // console.log("点击了新的菜单", val, oldName);
      },
    },
  },

  methods: {
    changeLang() {
      if (this.currnLang == 'zh-cn') {
        this.$i18n.locale = 'en-us'

        this.moment.locale('en-us')
        this.currnLang = 'en-us'
        this.otherLang = '切换中文'
      } else {
        this.$i18n.locale = 'zh-cn'

        this.moment.locale('zh-cn')
        this.currnLang = 'zh-cn';
        this.otherLang = 'Switch To English'
      }
    },
    // 点击一级菜单
    seleMenu(key, domEvent) {
      console.log('key', key)
      if (key == this.currents) return
      this.$router.push({
        path: `/${key}`,
      })
    },

    // 点击二级菜单
    selectChildren(item) {
      if (item.key == this.currents) return
      this.currents = `['${item.key}']`
      this.$router.push({
        path: `${item.path}`,
      })
    },
  }

}
</script>

<style lang="less" scoped>
.header-box {
  width: 100%;
  position: absolute;
  z-index: 999;

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding-top: 8px;
    color: #fff;
    transition: all 1s;
    background-color: rgba(0, 0, 0, 0.2);
    /* 添加半透明背景 */
    backdrop-filter: blur(8px);
    /* 添加模糊效果 */
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    /* 添加轻微阴影 */

    .logoBox {
      display: flex;
      align-items: center;

      .logo-img {
        width: 38px;
        height: auto;
      }

      .logo-name {
        font-size: 29px;
        line-height: 1;
        font-weight: 500;
        color: #ffffff;
        margin-left: 12px;
        width: 250px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      }
    }

    .generaPhone-box {
      border: 1px solid rgba(169, 157, 157, 0.4);
      border-radius: 8px;
      padding: 4px 15px;
      display: flex;
      align-items: center;

      .generaPhoneImg {
        width: 26px;
        height: 26px;
      }

      .generaPhone {
        font-size: 19px;
        font-weight: 500;
        color: #ffffff;
        padding-left: 20px;
      }
    }

    .header-left {
      display: flex;
      align-items: center;

      .menu-style {
        margin-left: 88px;
      }
    }

    .ant-menu-horizontal {
      // line-height: 80px !important;
      line-height: 5 !important;
      font-size: 16px;
      border-bottom: 1px solid transparent;
      background: transparent;
      color: #fff;

      .ant-menu-item-selected,
      .ant-menu-submenu-selected,
      .ant-menu-submenu-open,
      .ant-menu-item-open,
      .ant-menu-submenu-active .ant-menu-item-active,
      .ant-menu-submenu:hover,
      .ant-menu-item:hover {
        font-size: 18px;
        color: #fff;
        border-bottom: 2px solid #fff;
        font-weight: bold;
      }

      // .ant-sub-menu-active>.ant-menu-item-active {
      //   font-size: 18px;
      //   color: #fff;
      //   border-bottom: 2px solid #fff;
      //   font-weight: bold;
      // }
    }

    .ant-menu-item,
    .ant-menu-submenu-title {
      padding: 0 42px;
    }

    .ant-input {
      height: 47px;
      font-size: 17px;
    }

    .ant-input-affix-wrapper {
      font-size: 23px;
    }
  }

  .scrollTopFixed {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(20px);
    z-index: 9;
    box-shadow: 0px 1px 3px #fff;
    color: #000;

    .ant-menu-horizontal {
      // line-height: 80px !important;
      line-height: 5 !important;
      font-size: 16px;
      border-bottom: 1px solid transparent;
      background: transparent;
      color: #000;

      .ant-menu-item-selected,
      .ant-menu-submenu-selected,
      .ant-menu-submenu-open,
      .ant-menu-item-open,
      .ant-menu-submenu-active,
      .ant-menu-item-active,
      .ant-menu-submenu:hover,
      .ant-menu-item:hover {
        font-size: 18px;
        color: #007aff;
        border-bottom: 2px solid #007aff;
        font-weight: bold;
      }
    }

    .logoBox>.logo-name {
      color: #000;
    }

    // .generaPhone-box {
    //   padding: 4px 15px;
    //   // border: 1px solid red;
    //   border-radius: 8px;
    // }

    .generaPhone-box>.generaPhone {
      font-size: 19px;
      font-weight: 500;
      color: #000;
      padding-left: 20px;
    }
  }
}

.ant-menu-vertical .ant-menu-item {
  height: auto !important;
  line-height: 2.857 !important;
}

.langBtn {
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 1px 8px #eeeeee88;
  cursor: pointer;
  padding: 4px 15px;
  font-weight: bold;

  &:hover {
    box-shadow: 0 1px 8px #eee;
  }
}
</style>
